<template>
  <div class="content">
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img :src=picUrl alt=""/>
            <!-- <img src='../../assets/compute/compute_4.png' alt=""/> -->
          </div>
        </el-col>
        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <div>
                <span style="padding-right:10px;">{{$t('message.TypeSelection')}}</span>
                <el-cascader filterable :options="options" @change="handleItemChange" :props="props"></el-cascader>
                <div style="margin-top:30px;">
                  <router-link to="./">
                    <div class="button">{{$t('message.returnIndex')}}</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="elec_detail">
      <el-row>
        <el-col :span="24" style="margin-bottom:20px;">
          <h3>{{$t('message.ParameterInput')}}</h3>
          <!-- type_1 圆柱体-垂直 -->
          <el-form ref="form" :rules="rules" :model="form" label-width="200px" v-show="type_1" class="param_type_form">
            <el-form-item :label=compute2 prop="d0">
              <span class="first">d0</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d0" autocomplete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute1 prop="d1">
              <span class="first">d1</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.d1" autocomplete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute3 prop="L">
              <span class="first">L</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.L" autocomplete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute4 prop="p">
              <span class="first">ρ</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.p" autocomplete="off"></el-input>
              <span>(kg/m³)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form.e" autocomplete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- type_2 方形 -->
          <el-form ref="form2" :rules="rules2" :model="form2" label-width="200px" v-show="type_2" class="param_type_form">
            <el-form-item :label=compute3 prop="x">
              <span class="first">x</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form2.x" autocomplete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute8 prop="y">
              <span class="first">y</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form2.y" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute9 prop="z">
              <span class="first">z</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form2.z" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute4 prop="p">
              <span class="first">ρ</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form2.p" auto-complete="off"></el-input>
              <span>(kg/m³)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form2.e" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- type_3 圆柱体-平行 -->
          <el-form ref="form3" :rules="rules3" :model="form3" label-width="200px" v-show="type_3" class="param_type_form">
            <el-form-item :label=compute2 prop="d0">
              <span class="first">d0</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form3.d0" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute1 prop="d1">
              <span class="first">d1</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form3.d1" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute3 prop="L">
              <span class="first">L</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form3.L" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute4 prop="p">
              <span class="first">ρ</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form3.p" auto-complete="off"></el-input>
              <span>(kg/m³)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form3.e" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- 4  滚珠丝杆-->
          <el-form ref="form4" :rules="rules4" :model="form4" label-width="200px" v-show="type_4" class="param_type_form">
            <el-form-item :label=compute10 prop="p">
              <span class="first">p</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form4.p" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute6 prop="m">
              <span class="first">m</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form4.m" auto-complete="off"></el-input>
              <span>(kg)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- 5 球形-->
          <el-form ref="form5" :rules="rules5" :model="form5" label-width="200px" v-show="type_5" class="param_type_form">
            <el-form-item :label=compute11 prop="d">
              <span class="first">d</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form5.d" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute4 prop="p">
              <span class="first">ρ</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form5.p" auto-complete="off"></el-input>
              <span>(kg/m³)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form5.e" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- 6 饼形-->
          <el-form ref="form6" :rules="rules6" :model="form6" label-width="200px" v-show="type_6" class="param_type_form">
            <el-form-item :label=compute11 prop="d">
              <span class="first">d</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form6.d" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute12 prop="h">
              <span class="first">h</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form6.h" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item :label=compute4 prop="p">
              <span class="first">ρ</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form6.p" auto-complete="off"></el-input>
              <span>(kg/m³)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form6.e" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
          <!-- 7 任意物体-->
          <el-form ref="form7" :rules="rules7" :model="form7" label-width="200px" v-show="type_7" class="param_type_form">
            <el-form-item :label=compute13 prop="J0">
              <span class="first">J0</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form7.J0" auto-complete="off"></el-input>
              <span>(kg·c㎡)</span>
            </el-form-item>
            <el-form-item :label=compute14 prop="m">
              <span class="first">m</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form7.m" auto-complete="off"></el-input>
              <span>(kg)</span>
            </el-form-item>
            <el-form-item :label=compute5 prop="e">
              <span class="first">e</span>
              <el-input oninput="value=value.replace(/[^\d.]/g,'')" v-model="form7.e" auto-complete="off"></el-input>
              <span>(mm)</span>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="compute">{{$t('message.Compute')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <h3>{{$t('message.ComputationalResults')}}</h3>
          <el-form ref="form_result" :model="form_result" label-width="200px" v-show="type_compute" class="param_type_form">
            <el-form-item :label=compute6>
              <span class="first">m</span>
              <el-input v-model="form_result.m" :disabled="true"></el-input>
              <span>(kg)</span>
            </el-form-item>
            <el-form-item :label=compute7>
              <span class="first">J</span>
              <el-input v-model="form_result.J" :disabled="true"></el-input>
              <span>(kg·m²)</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="margin-bottom:50px;">
          <h3>{{$t('message.DensityReference')}}</h3>
          <el-table
            :data="tableData"
            style="width: 400px;margin-left:230px;color:#606266;">
            <el-table-column
              prop="name"
              label="名称 (Name)"
              width="180">
            </el-table-column>
            <el-table-column
              prop="density"
              label="密度 (Density)"
              width="180">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import {
    parallelcylinder,
    verticalcylinder,
    square,
    round,
    ballscrew,
    ball,
    anyobject
  } from '@/store/electric_compute'
  export default {
    name: 'ParamInput',
    data() {
      return {
        tableData: [{
          name: '铁 (Iron)',
          density: '7.9x10³kg/m³'
        }, {
          name: '铝 (Aluminum)',
          density: '2.8x10³kg/m³'
        }, {
          name: '黄铜 (Brass)',
          density: '8.5x10³kg/m³'
        }, {
          name: '尼龙 (Nylon)',
          density: '1.1x10³kg/m³'
        }, {
          name: '铸铁 (Cast Iron)',
          density: '7.4x10³kg/m³'
        }],
        options: [{
          value: 'type_1',
          label: this.$t('message.CylinderVertical')
        },{
          value: 'type_2',
          label: this.$t('message.Square')
        },{
          value: 'type_3',
          label: this.$t('message.CylinderParallel')
        },{
          value: 'type_4',
          label: this.$t('message.BallScrew')
        },{
          value: 'type_5',
          label: this.$t('message.spherical')
        },{
          value: 'type_6',
          label: this.$t('message.cake')
        },{
          value: 'type_7',
          label: this.$t('message.arbitraryObject')
        }],
        props: {
          label:'label',
          value:'value',
        },
        selectedOptions: [],
        tabPosition: 'left',
        picUrl:'',
        form: {
          d0:'',
          d1:'',
          L:'',
          p:'',
          e:''
        },
        rules:{
          d0:[
            {required: true, message: '必填项'},
          ],
          d1:[
            {required: true, message: '必填项'},
          ],
          L:[
            {required: true, message: '必填项'},

          ],
          p:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form2: {
          x:'',
          y:'',
          z:'',
          p:'',
          e:''
        },
        rules2:{
          x:[
            {required: true, message: '必填项'},

          ],
          y:[
            {required: true, message: '必填项'},

          ],
          z:[
            {required: true, message: '必填项'},

          ],
          p:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form3: {
          d0:'',
          d1:'',
          L:'',
          p:'',
          e:''
        },
        rules3:{
          d0:[
            {required: true, message: '必填项'},

          ],
          d1:[
            {required: true, message: '必填项'},

          ],
          L:[
            {required: true, message: '必填项'},

          ],
          p:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form4: {
          p:'',
          m:''
        },
        rules4:{
          p:[
            {required: true, message: '必填项'},

          ],
          m:[
            {required: true, message: '必填项'},

          ]
        },
        form5: {
          d:'',
          p:'',
          e:''
        },
        rules5:{
          d:[
            {required: true, message: '必填项'},

          ],
          p:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form6:{
          d:'',
          h:'',
          p:'',
          e:''
        },
        rules6:{
          d:[
            {required: true, message: '必填项'},

          ],
          h:[
            {required: true, message: '必填项'},

          ],
          p:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form7:{
          J0:'',
          m:'',
          e:''
        },
        rules7:{
          J0:[
            {required: true, message: '必填项'},

          ],
          m:[
            {required: true, message: '必填项'},

          ],
          e:[
            {required: true, message: '必填项'},

          ]
        },
        form_result: {
          m:'',
          J:''
        },
        type:{},
        type_1:false,
        type_2:false,
        type_3:false,
        type_4:false,
        type_5:false,
        type_6:false,
        type_7:false,
        type_compute:false,
        param:{},
        compute1:this.$t('message.compute1'),
        compute2:this.$t('message.compute2'),
        compute3:this.$t('message.compute3'),
        compute4:this.$t('message.compute4'),
        compute5:this.$t('message.compute5'),
        compute6:this.$t('message.compute6'),
        compute7:this.$t('message.compute7'),
        compute8:this.$t('message.compute8'),
        compute9:this.$t('message.compute9'),
        compute10:this.$t('message.compute10'),
        compute11:this.$t('message.compute11'),
        compute12:this.$t('message.compute12'),
        compute13:this.$t('message.compute13'),
        compute14:this.$t('message.compute14'),
      }
    },
    mounted(){
      this.picUrl = '../../../static/seriesPic/KPL.png'
    },
    methods: {
      toNextPage:function(){
        this.$emit("listenPageChange","to_CompletedPage");
      },
      handleItemChange(val) {
        if(val[0] === 'type_1'){
          this.picUrl = '/static/compute/compute_2.png'
          this.type_1 = true;
          this.type_2 = false;
          this.type_3 = false;
          this.type_4 = false;
          this.type_5 = false;
          this.type_6 = false;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_2'){
          this.picUrl = '/static/compute/compute_3.png'
          this.type_1 = false;
          this.type_2 = true;
          this.type_3 = false;
          this.type_4 = false;
          this.type_5 = false;
          this.type_6 = false;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_3'){
          this.picUrl = '/static/compute/compute_1.png'
          this.type_1 = false;
          this.type_2 = false;
          this.type_3 = true;
          this.type_4 = false;
          this.type_5 = false;
          this.type_6 = false;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_4'){
          this.picUrl = '/static/compute/compute_5.png'
          this.type_1 = false;
          this.type_2 = false;
          this.type_3 = false;
          this.type_4 = true;
          this.type_5 = false;
          this.type_6 = false;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_5'){
          this.picUrl = '/static/compute/compute_6.png'
          this.type_1 = false;
          this.type_2 = false;
          this.type_3 = false;
          this.type_4 = false;
          this.type_5 = true;
          this.type_6 = false;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_6'){
          this.picUrl = '/static/compute/compute_4.png'
          this.type_1 = false;
          this.type_2 = false;
          this.type_3 = false;
          this.type_4 = false;
          this.type_5 = false;
          this.type_6 = true;
          this.type_7 = false;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }else if(val[0] === 'type_7'){
          this.picUrl = '/static/compute/compute_7.png'
          this.type_1 = false;
          this.type_2 = false;
          this.type_3 = false;
          this.type_4 = false;
          this.type_5 = false;
          this.type_6 = false;
          this.type_7 = true;
          this.type_compute = true;
          this.type.param = val[0];
          this.form_result.m = '';
          this.form_result.J = '';
        }
      },
      compute(){
        if(this.type.param === 'type_1'){
          if(this.form.d0 === ''|| this.form.d1 === ''|| this.form.L === '' || this.form.p === '' || this.form.e === ''){
            console.log(this.form);
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }else{
            this.param.d0 = this.form.d0;
            this.param.d1 = this.form.d1;
            this.param.L = this.form.L;
            this.param.p = this.form.p;
            this.param.e = this.form.e;
            verticalcylinder(this.param).then((response)=>{
              if(response.success === true){
                this.form_result.J = response.data.J;
                this.form_result.m = response.data.m;
              }
            })
          }
        }else if(this.type.param === 'type_2'){
          if(this.form2.x === '' || this.form2.y === '' || this.form2.z ==='' || this.form2.p === '' || this.form2.e === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.x = this.form2.x;
          this.param.y = this.form2.y;
          this.param.z = this.form2.z;
          this.param.p = this.form2.p;
          this.param.e = this.form2.e;
          square(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              this.form_result.m = response.data.m;
            }
          })
        }else if(this.type.param === 'type_3'){
          if(this.form3.d0 === '' || this.form3.d1==='' || this.form3.L==='' || this.form3.p==='' || this.form3.e === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.d0 = this.form3.d0;
          this.param.d1 = this.form3.d1;
          this.param.L = this.form3.L;
          this.param.p = this.form3.p;
          this.param.e = this.form3.e;
          parallelcylinder(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              this.form_result.m = response.data.m;
            }
          })
        }else if(this.type.param === 'type_4'){
          if(this.form4.p==='' || this.form4.m === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.p = this.form4.p;
          this.param.m = this.form4.m;
          ballscrew(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              //this.form_result.m = response.data.m;
              this.form_result.m = this.form4.m;
            }
          })
        }else if(this.type.param === 'type_5'){
          if(this.form5.d==='' || this.form5.p==='' || this.form5.e === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.d = this.form5.d;
          this.param.p = this.form5.p;
          this.param.e = this.form5.e;
          ball(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              this.form_result.m = response.data.m;
            }
          })
        }else if(this.type.param === 'type_6'){
          if(this.form6.d==='' || this.form6.p==='' || this.form6.h==='' || this.form6.e === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.d = this.form6.d;
          this.param.p = this.form6.p;
          this.param.h = this.form6.h;
          this.param.e = this.form6.e;
          round(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              this.form_result.m = response.data.m;
            }
          })
        }else if(this.type.param === 'type_7'){
          if(this.form7.J0==='' || this.form7.m==='' || this.form7.e === ''){
            this.$message({
              message: '表单填写有误！请检查',
              type: 'warning'
            });
            return false;
          }
          this.param.J0 = this.form7.J0;
          this.param.m = this.form7.m;
          this.param.e = this.form7.e;
          anyobject(this.param).then((response)=>{
            if(response.success === true){
              this.form_result.J = response.data.J;
              this.form_result.m = response.data.m;
            }
          })
        }
      }
    }
  };
</script>
<style scoped>
  .content {
    width:100%;
    height: 100%;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .elec_select_left img{
    width: 200px;
    height: 200px;
    display: block;
    margin: 0 auto;
    padding-top: 100px;
    padding-left: 80px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
  }
  .select_box {
    padding-left:10px;
    padding-top:160px;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
    margin-left:350px;
    margin-bottom:50px;
  }
  .param_type_form {
    margin-left:100px;
  }
  .param_type_form .first{
    width:20px;
    display:inline-block;
    padding-left:10px;
  }
  .param_type_form .el-input{
    width:30%;
  }
  .param_type_form .el-button{
    width:100px;
    margin-left:34px;
    background:#142479;
    border:none;
  }
  .button {
    display: inline-block;
    width:97px;
    height:42px;
    background:#142479;
    border-radius: 5px;
    color:#F4F4F4;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    margin-bottom:40px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .elec_detail {
      width:80%;
      margin:0 auto;
      margin-top:70px;
      margin-left:200px;
      margin-bottom:50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/MomentInertia/ParamInput.vue